import { render, staticRenderFns } from "./AddContent.vue?vue&type=template&id=70a77ea0"
import script from "./AddContent.vue?vue&type=script&lang=js"
export * from "./AddContent.vue?vue&type=script&lang=js"
import style0 from "./AddContent.vue?vue&type=style&index=0&id=70a77ea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports